/* TGP Mobile-Menü – Drill-down im Drawer.
   Tippe „into" → tiefer (Panel slidet rein), „back" → eine Ebene zurück.
   Aktive Ebenen = Stack; Panels stapeln per z-index (depth). Kein Framework. */
(function () {
  function init() {
    var root = document.querySelector('.tgp-m[data-tgp-mobile]');
    if (!root) return;
    var rootPanel = root.querySelector('[data-root]');
    var stack = [rootPanel];

    function render() {
      var cur = stack[stack.length - 1];
      var panels = root.querySelectorAll('.tgp-m__panel');
      for (var i = 0; i < panels.length; i++) {
        panels[i].classList.toggle('is-active', panels[i] === cur);
      }
      root.classList.toggle('is-drilled', stack.length > 1);
    }
    function reset() { stack = [rootPanel]; render(); }

    root.addEventListener('click', function (e) {
      var into = e.target.closest('.tgp-m__into');
      if (into && root.contains(into)) {
        var t = document.getElementById(into.getAttribute('data-to'));
        if (t) { stack.push(t); render(); }
        return;
      }
      var back = e.target.closest('.tgp-m__back');
      if (back && root.contains(back)) {
        if (stack.length > 1) { stack.pop(); render(); }
        return;
      }
    });

    // Beim Öffnen/Schließen des Drawers zur Startebene zurück
    var toggles = document.querySelectorAll('[aria-controls="MenuDrawer"]');
    for (var j = 0; j < toggles.length; j++) toggles[j].addEventListener('click', reset);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
